import React, { ReactNode } from "react";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: ReactNode;
}

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, title, children }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-800 bg-opacity-75 flex items-start justify-center pt-10 z-50">
      <div className="bg-white rounded-lg shadow-lg max-w-4/5 p-6 relative">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
          aria-label="Close"
        >
          &times;
        </button>
        <div className="flex mb-4">
          <div className="border-l-8 rounded-3xl border-slate-100 mr-4"></div>
          {title && (
            <h2 className="text-lg text-slate-500 font-black">{title}</h2>
          )}
        </div>
        <div>{children}</div>
      </div>
    </div>
  );
};

export default Modal;
